import { Box, Grid, Tooltip } from '@mui/material'
import { isArray } from 'lodash';
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography'
import { VerificationCompanyAtom } from '../../../../State/VerificationCompany.Atom';
import {
    VerificationAgencyClientApplication
} from "../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import {
    VerificationAgencyClientApplicationService
} from "../../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService";
import { LoadingButton } from "@mui/lab";
import { CommisionerValidationSchema } from './CommisionerValidationSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import AppYesOrNoSelector from '../../../../Component/Common/Components/FormValidationInputs/AppYesOrNoSelector';
import AppTextInput from '../../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { IntermediateGlobalLoading } from '../../../../Component/Common/Components/Loading/IntermediateGlobalLoading';
import { MDBox } from '../../../../Component/Common/Components/MDBox';


export const CommisionerDetails = () => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const [loading, setLoading] = React.useState(false);
    const [application, setApplication] = React.useState<VerificationAgencyClientApplication.VerificationAgencyClientApplicationResponse>();
    const [commisionerDetails, setCommisionerDetails] = React.useState(-1);
    const { control, handleSubmit, formState: { isSubmitting }, reset, watch } = useForm({
        mode: 'all',
        resolver: yupResolver(CommisionerValidationSchema),
    });

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                VaClientApplicationId: verificationCompany.applicationId,
                HasReportedToBeeCommisioner: !!data.HasReportedToBeeCommisioner,
                IsBusinessUnderInvestigation: !!data.IsBusinessUnderInvestigation,
                BusinessUnderInvestigationDetail: data.BusinessUnderInvestigationDetail,
                ReportedToBEECommisionerDetail: data.ReportedToBEECommisionerDetail
            } as VerificationAgencyClientApplication.VerificationAgencyBeeCommisionerDtoIn;
            if (commisionerDetails < 0 || !commisionerDetails) {
                var response = await VerificationAgencyClientApplicationService.CreateBeeCommisioner(requestData);
                setCommisionerDetails(response.data.beeCommisionerId);
            }
            else {
                await VerificationAgencyClientApplicationService.UpdateBeeCommisioner(requestData);
            }
            toast.success("BEE Commisioner Details Saved")
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const fetchCommisionerDetails = async () => {
        const id = verificationCompany.applicationId;
        try {
            const response = await VerificationAgencyClientApplicationService.GetBEECommisioner(id);
            setCommisionerDetails(response.data.beeCommisionerId);
            const formData = {
                IsBusinessUnderInvestigation: response.data.isBusinessUnderInvestigation,
                HasReportedToBeeCommisioner: response.data.hasReportedToBeeCommisioner,
                BusinessUnderInvestigationDetail: response.data.businessUnderInvestigationDetail,
                ReportedToBEECommisionerDetail: response.data.reportedToBEECommisionerDetail
            };
            reset(formData);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchApplication = async () => {
        try {
            const response = await VerificationAgencyClientApplicationService.GetById(verificationCompany.applicationId);
            setApplication(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchData = async () => {
        setLoading(true);
        if (verificationCompany.applicationId !== -1) {
            const commissionerPromise = fetchCommisionerDetails();
            const applicationPromise = fetchApplication();
            await Promise.all([commissionerPromise, applicationPromise]);
        }
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, [verificationCompany.applicationId]);

    const isBusinessUnderInvestigation = watch("IsBusinessUnderInvestigation");
    const hasReportedToBeeCommisioner = watch("HasReportedToBeeCommisioner");
    const showBusinessUnderInvestigationDetail = Boolean(isBusinessUnderInvestigation);
    const showReportedToBeeCommisionerDetail = Boolean(hasReportedToBeeCommisioner);

    if (loading) {
        return (<IntermediateGlobalLoading />);
    }
    return (
        <Box>
            <MDBox style={{ marginBottom: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold'>
                    Application - {application?.referenceNumber}
                </MDTypography>
            </MDBox>
            <MDTypography graphy color='primary' variant='h6' fontWeight='bold' sx={{ mb: 2 }} >
                BEE Commissioner
            </MDTypography>
            <Grid container spacing={3} component="form" id='ApplicationDetailsForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container item xs={11} spacing={2}>
                    <Grid item xs={12}>
                        <AppYesOrNoSelector control={control} name="IsBusinessUnderInvestigation" label='Is your business or any part of their structure or dealings currently under investigation?' size="small" />
                    </Grid>
                    {showBusinessUnderInvestigationDetail &&
                        <Grid item xs={12}>
                            <AppTextInput control={control} name="BusinessUnderInvestigationDetail" label='Please provide some additional information' multiline rows={5} />
                        </Grid>
                    }
                </Grid>
                <Grid container item xs={11} spacing={2}>
                    <Grid item xs={12}>
                        <Tooltip title={"Has your business had any part of their structure or dealings reported to the BBBEE Commission, either voluntarily/ internally or by any other party?"}>
                            <AppYesOrNoSelector control={control} name="HasReportedToBeeCommisioner" label='Has your business had any part of their structure or dealings reported to the BBBEE Commission, either voluntarily/ internally or by any other party?' size="small" />
                        </Tooltip>
                    </Grid>
                    {showReportedToBeeCommisionerDetail &&
                        <Grid item xs={12}>
                            <AppTextInput control={control} name="ReportedToBEECommisionerDetail" label='Please provide some additional information' multiline rows={5} />
                        </Grid>
                    }
                </Grid>
                <Grid item xs={11}>
                    <Grid item xs={12}>
                        <LoadingButton loading={isSubmitting} variant='contained' form='ApplicationDetailsForm' type="submit" color='primary'>
                            Save
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}
